<template>
    <div class="navText-wrapper">
        <h1 ref="navText">{{ sectionName }}</h1>
    </div>
</template>

<script>
export default {
   name: 'NavText',
   props: ['sectionName'],
   methods: {
    roundColor() {
        this.$refs.navText.style.color = "#2D7BE5";
    },
    flatColor() {
        this.$refs.navText.style.color = "#459300";
    },
    hollowColor() {
        this.$refs.navText.style.color = "#D2841A";
    }
   }
//    methods: {
//         handleScroll() {
//             // console.log("scrolling");
//             var scrollPos = window.scrollY;
//             var winHeight = window.innerHeight;
//             var docHeight = document.documentElement.scrollHeight;
//             var perc = 100 * scrollPos / (docHeight - winHeight);
//             // this.$refs.progress.style.height = perc + '%';
//             console.log(this.$refs)
//             console.log(scrollPos+" "+perc);
//             // setTimeout(1000);
//         }
//     },
//     created() {
//         window.addEventListener('scroll', this.handleScroll);
//     }
}
</script>
<style scoped>
    .navText-wrapper {
        transform: rotate(-90deg) translateX(-100%);
        transform-origin: top left;
        position: fixed;
        top: calc(20vh - 5px);
        left: 155px;
        color: #2D7BE5;
        transition: color 1s ease-in-out;
    }

    .navText-wrapper h1 {
        /* transform: rotate(-90deg) translateY(-150%) translateX(-50%); */
        margin: 0;
        font-size: 36px;
        transition: color 1s ease-in-out;
    }
</style>